const BadgeController = require('./badge-controller');


module.exports = function () {
    return {
        restrict: 'E',
        controllerAs: 'ctrl',
        controller: BadgeController,
        bindToController: {
            topText: '=',
            bottomText: '=',
            promotionalPrice: '=',
            size: '@?',
            showAsterisk: '=?'
        },
        scope: {},
        template: require('./percentage-off-badge-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/badges/percentage-off-badge-directive.js
 **/